import TokenBannerEditor from '@/components/TokenBannerEditor'
import { isHttpImageUrl } from '@/lib/tokenImage'
import type { ProjectLinkKind } from '@/lib/projectLinks'

export default function TokenPageBanner({
  name,
  banner,
  projectKeys,
  kind,
  creatorAddress,
  accent = 'lime',
  onPublished,
}: {
  name: string
  banner?: string
  projectKeys: Array<string | undefined>
  kind: ProjectLinkKind
  creatorAddress?: string
  accent?: 'lime' | 'orange'
  onPublished?: (banner: string) => void
}) {
  const src = banner && isHttpImageUrl(banner) ? banner : undefined

  return (
    <div className={src ? 'relative mt-5 overflow-visible' : undefined}>
      {src
        ? (
            <div className="overflow-hidden rounded-3xl border border-white/10 bg-zinc-950">
              <img
                src={src}
                alt={`${name} banner`}
                className="aspect-[5/2] w-full object-cover object-center sm:aspect-[4/1]"
              />
            </div>
          )
        : null}
      <TokenBannerEditor
        projectKeys={projectKeys}
        kind={kind}
        creatorAddress={creatorAddress}
        currentBanner={src}
        accent={accent}
        onPublished={onPublished}
      />
    </div>
  )
}
